module.exports = __webpack_public_path__ + "img/footer-phone-icon.ca5e6376.svg";